import {LeaderboardStrategy} from "./leaderboardStrategy";
import {LeaderboardStrategyFastaily} from "./leaderboardStrategyFastaily";


export const getLeaderboardStrategy = (isFastaily: boolean): LeaderboardStrategy => {
    return isFastaily ? new LeaderboardStrategyFastaily(): new LeaderboardStrategy();
}
